import { useHotkey } from "@tanstack/react-hotkeys";
import { useState } from "react";

export default function useToggleDiagnostics() {
    const [open, setOpen] = useState<boolean>(false);

    useHotkey("Alt+Shift+Backspace", () => setOpen((current) => !current), { ignoreInputs: true });

    return [open, setOpen] as const;
}
